require('dom-slider');
const {slideToggle} = window.domSlider;

const accordionButtons = document.querySelectorAll('.accordion__button');

const toggleAccordion = (e) => {
    e.preventDefault();

    e.currentTarget.classList.toggle('active');

    slideToggle({
        element: e.currentTarget.parentElement.querySelector('.accordion__content')
    });
};

const accordion = () => {
    if (accordionButtons.length) {
        accordionButtons.forEach(accordionButton => {
            accordionButton.addEventListener('click', toggleAccordion);
        });
    }
};

export default accordion;